import {
  testIsValidCVE,
  testIsValidCWE,
  testIsValidGHSA
} from "@/domain/vulnerability"

export const testIsValidID = (value: string) =>
  testIsValidCVE(value) || testIsValidGHSA(value)

export const ghsaValidator = (_: unknown, value: string[]) => {
  if (!value?.every(testIsValidGHSA)) return Promise.reject()

  return Promise.resolve()
}

// Validate the vulnerability ID to be either a CVE or GHSA ID
export const vulnerabilityIDValidator = (_: unknown, value: string[]) => {
  if (!value?.every((v) => testIsValidID(v))) return Promise.reject()

  return Promise.resolve()
}

export const cweIDValidator = (_: unknown, value: string[]) => {
  if (!value?.every((v) => testIsValidCWE(v))) return Promise.reject()

  return Promise.resolve()
}

const STATUS_MODIFICATIONS = ["RESOLVED", "DISMISSED"]

// Selected modifications must all match one change, so a status change can't be combined with others.
export const issueModificationOptions = <T extends { value: string }>(
  options: T[] = [],
  selected: string[] = []
): (T & { disabled?: boolean })[] => {
  const statusSelected = selected.some((value) =>
    STATUS_MODIFICATIONS.includes(value)
  )
  const otherSelected = selected.some(
    (value) => !STATUS_MODIFICATIONS.includes(value)
  )
  return options.map((option) => {
    if (selected.includes(option.value)) return option
    const isStatus = STATUS_MODIFICATIONS.includes(option.value)
    const incompatible = statusSelected || (otherSelected && isStatus)
    return incompatible ? { ...option, disabled: true } : option
  })
}
